import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { from, Observable } from 'rxjs';

import { environment } from '@environments/environment';
import { AccountService } from '@app/_services';
import { Auth } from 'aws-amplify';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private accountService: AccountService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
                       
        return from(this.handle(request, next))
    }

    async handle(request: HttpRequest<any>, next: HttpHandler) {
        
        let authToken: string; 
        try {
            authToken = (await Auth.currentAuthenticatedUser())
            .getSignInUserSession()
            .getAccessToken()
            .getJwtToken();
        } catch (error) {

        }


        let authRequest = request;        

        const isApiUrl = request.url.startsWith(environment.apiUrl);
        if (isApiUrl && authToken) {
            authRequest = request.clone({
            setHeaders: {
                Authorization: authToken
                },
            });
        }
    
        // Important: Note the .toPromise()
        return next.handle(authRequest).toPromise()
      }
}